import type { ReactNode } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router'
import { useAnmeldung } from './lib/anmeldung'
import { useTeststand } from './lib/test'
import { Kopfzeile } from './teile/Kopfzeile'
import { AnmeldungSeite } from './seiten/Anmeldung'
import { TestStartSeite } from './seiten/Test'
import { BedingungenSeite } from './seiten/Bedingungen'
import { ImpressumSeite } from './seiten/Impressum'
import { DatenschutzSeite } from './seiten/Datenschutz'
import { EingangSeite } from './seiten/Eingang'
import { MandantenSeite } from './seiten/Mandanten'
import { MandantSeite } from './seiten/Mandant'
import { ExporteSeite } from './seiten/Exporte'
import { AuszugSeite } from './seiten/Auszug'
import { VerwaltungSeite } from './seiten/Verwaltung'

/** Rahmen fuer alle Arbeitsseiten. Die Reiterzeile benennt die Seite. */
function Rahmen({ children }: { children: ReactNode }) {
  return (
    <>
      <Kopfzeile />
      <main className="inhalt">{children}</main>
    </>
  )
}

export function App() {
  const { auskunft, laedt } = useAnmeldung()
  const { stand, laedt: testLaedt, registrieren } = useTeststand()
  const ort = useLocation()

  // Rechtsseiten muessen immer erreichbar sein, auch ohne Zugang (die
  // Bedingungen schon vor dem Haekchen, Impressum und Datenschutz als Pflicht).
  if (ort.pathname === '/bedingungen') return <BedingungenSeite />
  if (ort.pathname === '/impressum') return <ImpressumSeite />
  if (ort.pathname === '/datenschutz') return <DatenschutzSeite />

  if (laedt || testLaedt) return <div className="laedt">Einen Moment …</div>

  if (!auskunft) {
    return stand.test ? <TestStartSeite stand={stand} registrieren={registrieren} /> : <AnmeldungSeite />
  }

  // Die Verwaltung (H&K) sieht Kanzleien und Zugaenge, keine Mandantendaten.
  if (auskunft.benutzer.rolle === 'verwaltung') {
    return (
      <Routes>
        <Route path="/verwaltung" element={<Rahmen><VerwaltungSeite /></Rahmen>} />
        <Route path="*" element={<Navigate to="/verwaltung" replace />} />
      </Routes>
    )
  }

  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/eingang" replace />} />
        <Route path="/eingang" element={<Rahmen><EingangSeite /></Rahmen>} />
        <Route path="/mandanten" element={<Rahmen><MandantenSeite /></Rahmen>} />
        <Route path="/mandanten/:id" element={<Rahmen><MandantSeite /></Rahmen>} />
        <Route path="/exporte" element={<Rahmen><ExporteSeite /></Rahmen>} />
        {/* Bewusst ohne Rahmen: im geoeffneten Auszug gehoert der Bildschirm
            dem Auszug, die Hauptnavigation tritt zurueck. */}
        <Route path="/auszuege/:id" element={<AuszugSeite />} />
        <Route path="*" element={<Navigate to="/eingang" replace />} />
      </Routes>
    </>
  )
}
